/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchUpdateOriginReqVo
 */
export interface BatchUpdateOriginReqVo {
    /**
     * 商品ID，可为合包商品或基础商品
     * 商品ID列表，可为合包或基础商品
     * @type {Array<number>}
     * @memberof BatchUpdateOriginReqVo
     */
    goodsIds: Array<number>;
    /**
     * 原产地，如 Y/N 或国家编码
     * 原产地
     * @type {string}
     * @memberof BatchUpdateOriginReqVo
     */
    origin: string;
}

/**
 * Check if a given object implements the BatchUpdateOriginReqVo interface.
 */
export function instanceOfBatchUpdateOriginReqVo(value: object): value is BatchUpdateOriginReqVo {
    if (!('goodsIds' in value) || value['goodsIds'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function BatchUpdateOriginReqVoFromJSON(json: any): BatchUpdateOriginReqVo {
    return BatchUpdateOriginReqVoFromJSONTyped(json, false);
}

export function BatchUpdateOriginReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchUpdateOriginReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsIds': json['goodsIds'],
        'origin': json['origin'],
    };
}

export function BatchUpdateOriginReqVoToJSON(json: any): BatchUpdateOriginReqVo {
    return BatchUpdateOriginReqVoToJSONTyped(json, false);
}

export function BatchUpdateOriginReqVoToJSONTyped(value?: BatchUpdateOriginReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsIds': value['goodsIds'],
        'origin': value['origin'],
    };
}

